
import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import SignalRService from '../controllers/SignalRService';
class CheckToken extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loggedIn: localStorage.getItem("fc-logged")
        };
        this.setLogged = this.setLogged.bind(this);
        this.getAppResult = this.getAppResult.bind(this);
        this.toastrRef = React.createRef();

        SignalRService.registerGetApp(this.getAppResult);
    }

    setLogged(value) {
        this.setState({
            loggedIn: value
        });
    };

    getAppResult(loggedIn) {
        this.setLogged(loggedIn);
    }

    render() {
        let ret = this.props.children || (<><Navigate to='/main/interactions' /></>);
        if (!this.state.loggedIn) {
            ret = (<><Navigate to='/login' /></>);
        }
        return ret;
    };
}


export default CheckToken;
